/* import __COLOCATED_TEMPLATE__ from './fin-agent-api-bot-channel.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    section: any;
    config: any;
    isDisabled: boolean;
  };
}

const FinAgentApiBotChannel = templateOnlyComponent<Signature>();
export default FinAgentApiBotChannel;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::CustomBots::FinAgentApiBotChannel': typeof FinAgentApiBotChannel;
  }
}
